import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"

// import PropTypes from "prop-types"
// import { isEmpty } from "lodash"
// import TableContainer from "../../../components/Common/TableContainer"
// import * as Yup from "yup"
// import { useFormik } from "formik"

//import components
// import Breadcrumbs from "../../../components/Common/Breadcrumb"
// import DeleteModal from "../../../components/Common/DeleteModal"
//Import Flatepicker
// import "flatpickr/dist/themes/material_blue.css"
// import Flatpickr from "react-flatpickr"

// import {
//   getOrders as onGetOrders,
//   addNewOrder as onAddNewOrder,
//   updateOrder as onUpdateOrder,
//   deleteOrder as onDeleteOrder,
// } from "store/actions"

//redux
// import { useSelector, useDispatch } from "react-redux"
// import { createSelector } from "reselect"
// import EcommerceOrdersModal from "./EcommerceOrdersModal"

import {
  Button,
  Col,
  Row,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Accordion,
  CardBody,
} from "reactstrap"
import { ToastContainer } from "react-toastify"
import Spinners from "components/Common/Spinner"
import API_SERVICE from "shared/services/api-services"
import { downloadFile, notification } from "shared/utility/Utility"

function RegistrationDetails() {
  const [isLoading, setLoading] = useState(false)
  const [registrationData, setRegistrationData] = useState({})
  const [open, setOpen] = useState([0])

  const { id } = useParams()

  document.title = "Inventya"

  useEffect(() => {
    const getRegistrationDetails = async () => {
      try {
        const {
          data: { data },
        } = await API_SERVICE.getRegistrationDetails(id)
        setRegistrationData(data)
      } catch (error) {
        notification("error", API_SERVICE.handleErrors(error))
      }
    }
    getRegistrationDetails()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          {isLoading ? (
            <Row
              style={{
                height: "calc(100vh - 160px)",
              }}
            >
              <Col xs={12}>
                <Spinners setLoading={setLoading} />
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                <Col xs={12}>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-18">
                      Registration Details |{" "}
                      <span
                        style={{
                          color: "#E4661D",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        {registrationData?.companyName}{" "}
                      </span>{" "}
                      |{" "}
                      <span
                        style={{
                          color: "#E4661D",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        #INVG
                        {registrationData?.id}{" "}
                      </span>
                      |{" "}
                      <span
                        style={{
                          color: "#E4661D",
                          fontSize: "18px",
                          fontWeight: "500",
                        }}
                      >
                        {" "}
                        {registrationData?.country}{" "}
                      </span>
                    </h4>
                    <div
                      style={{ cursor: "pointer" }}
                      className="page-title-right primary text-primary"
                      onClick={async () => {
                        try {
                          setLoading(true)
                          const res = await API_SERVICE.exportRegistration(
                            registrationData?.id
                          )
                          downloadFile(
                            res,
                            `${registrationData.companyName}-Registration Details.pdf`,
                            "application/pdf"
                          )
                        } catch (e) {
                          notification("error", e)
                        } finally {
                          setLoading(false)
                        }
                      }}
                    >
                      Download Report
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" className="d-flex  justify-content-end">
                  <Button
                    className="  btn-sm d-flex gap-2 outline-none shadow-none border-0 text-white bg-primary"
                    onClick={() => {
                      setOpen(item =>
                        item.length === registrationData?.segments?.length
                          ? []
                          : registrationData?.segments?.map((_, i) => i)
                      )
                    }}
                  >
                    {open.length === registrationData?.segments?.length ? (
                      <>
                        <i className="mdi mdi-arrow-up"></i>
                        <span>Collapse All</span>
                      </>
                    ) : (
                      <>
                        <i className="mdi mdi-arrow-down"></i>
                        <span>Expand All</span>
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  {registrationData?.segments?.map((item, index) => {
                    return (
                      <MyAccordian
                        item={item?.segment}
                        key={index}
                        index={index}
                        open={open}
                        setOpen={setOpen}
                      />
                    )
                  })}
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

const MyAccordian = ({ item, index, open, setOpen }) => {
  const toggle = id => {
    if (open.includes(id)) {
      setOpen(open.filter(i => i !== id))
    } else {
      setOpen([...open, id])
    }
  }

  return (
    <Accordion open={open} toggle={toggle} className="accordion-flush">
      <CardBody>
        <AccordionItem className="my-5">
          <AccordionHeader targetId={index}>
            <p
              style={{
                color: "#E4661D",
                fontSize: "18px",
                fontWeight: "700",
              }}
              className="custom-acc"
            >
              {item?.name}
            </p>
          </AccordionHeader>
          <AccordionBody accordionId={index} key={`inner${index}`}>
            {item?.questions?.map((ques, i) => {
              return (
                <>
                  <div
                    style={{
                      padding: "8px",
                      borderTopRightRadius: "20px",
                      borderBottomRightRadius: "20px",
                      backgroundColor: "#E4661D",
                      color: "#FFFFFF",
                      height: "30px",
                      width: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                    }}
                  >
                    {` Q ${i + 1}`}
                  </div>
                  <div style={{ marginLeft: "60px" }}>
                    <strong>{ques?.question}</strong>
                    <br />
                    {ques?.answers?.length > 1 ? (
                      <ul style={{ paddingLeft: "1rem" }}>
                        {ques?.answers?.map((ans, i) => (
                          <li key={i}>{ans?.answer}</li>
                        ))}
                      </ul>
                    ) : (
                      ques?.answers[0]?.answer
                    )}
                  </div>
                </>
              )
            })}
          </AccordionBody>
        </AccordionItem>
      </CardBody>
    </Accordion>
  )
}
export default RegistrationDetails
